export default "__VITE_ASSET__0SwJ_Vxq__"